module.exports = __webpack_public_path__ + "static/media/subway-ticketmachine-front.6dfff079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenes/subway-ticketmachine-front.png
// module id = 172
// module chunks = 0